export const formatMoney = (value: number | string | null | undefined) => {
  const numericValue = Number(value || 0)

  if (Math.abs(numericValue) >= 100000) {
    const inMillions = numericValue / 1000000
    return `€ ${inMillions.toFixed(2)} M`
  }

  return `€ ${numericValue.toFixed(2)}`
}

// Separated bars are ~11px wide, so their labels drop the € and the cents to fit.
export const formatCompactMoney = (value: number | string | null | undefined) => {
  const numericValue = Number(value || 0)
  const magnitude = Math.abs(numericValue)

  if (magnitude >= 100000) {
    return `${(numericValue / 1000000).toFixed(2)}M`
  }
  if (magnitude >= 1000) {
    return `${(numericValue / 1000).toFixed(1)}k`
  }

  return `${Math.round(numericValue)}`
}

export const toAmount = (value: unknown) => {
  const numericValue = Number(value ?? 0)
  return Number.isFinite(numericValue) ? numericValue : 0
}
